import mainModule from '../modules/main/index';

console.log(`Module ${mainModule} is running`);
